import React, { useState } from "react";
import { Table } from "react-bootstrap";
import { HiOutlineChevronDown, HiOutlineChevronUp } from "react-icons/hi";
// import Checkbox from "../checkBox/Checkbox";
import Pagination from "./Pagination";
import "./Datatable.css";
import SearchBar from "./SearchBar";

export const Datatable = ({
    data,
    columns,
    // checkbox,
    isSearchBar,
    children,
    rowClick,
    isLoader,
    tableNm,
    pagination,
    tableBtn,
    height,
    isHeaderFixed
}) => {

    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [sortColumn, setSortColumn] = useState(null);
    const [sortDirection, setSortDirection] = useState(null);

    // Function to handle sorting
    const handleSort = (column) => {
        if (sortColumn === column) {
            setSortDirection((prevDirection) =>
                prevDirection === "asc" ? "desc" : "asc"
            );
        } else {
            setSortColumn(column);
            setSortDirection("asc");
        }
    };

    // Helper function to filter the data based on the HiOutlineSearch term
    const filterData = (data) => {
        return isSearchBar ? data.filter((item) =>
            Object.values(item).some((value) =>
                value.toString().toLowerCase().includes(searchTerm.toLowerCase())
            )
        ) : data;
    };

    // Sort the filtered data
    const sortedData = sortColumn
        ? filterData(data).sort((a, b) => {
            const aValue = a[sortColumn];
            const bValue = b[sortColumn];

            if (aValue < bValue) return sortDirection === "asc" ? -1 : 1;
            if (aValue > bValue) return sortDirection === "asc" ? 1 : -1;
            return 0;
        })
        : filterData(data);

    // Get total number of pages
    const totalPages = Math.ceil(sortedData.length / itemsPerPage);

    // Get current items for pagination
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = pagination ? sortedData.slice(indexOfFirstItem, indexOfLastItem) : sortedData;


    return (
        <div>
            <>
                <div className="overflow-x-auto">
                    <div className="inline-block w-100 align-middle">
                        {isSearchBar &&
                            <div className="d-flex align-items-center gap-2">
                                <SearchBar searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
                                {tableBtn}
                            </div>
                        }
                        <div className={`border rounded mt-3 ${isHeaderFixed ? "fixed-TableHeader" : ""}  overflow-auto`} style={{ height: height || "auto" }}>
                            <Table responsive="sm" hover className="w-100 mb-0">
                                <thead>
                                    <tr className="tableheader">
                                        {columns.map((column, index) => {
                                            return (
                                                <th
                                                    key={index}
                                                    onClick={() => column.sorting && handleSort(column.field)}
                                                    className="p-2 text-sm"
                                                    style={{ width: column.width }}
                                                >
                                                    <div className={`d-flex align-items-center text-sm text-nowrap`} style={{ justifyContent: column.align || "between" }}>
                                                        {column.header}
                                                        {sortColumn === column.field && column.sorting && (
                                                            <span className="ms-auto">
                                                                {sortDirection === "asc" ? (
                                                                    <HiOutlineChevronDown />
                                                                ) : (
                                                                    <HiOutlineChevronUp />
                                                                )}
                                                            </span>
                                                        )}
                                                    </div>
                                                </th>
                                            );
                                        })}
                                    </tr>
                                </thead>
                                <tbody className="bg-white divide-y divide-slate-100">
                                    {currentItems.map((row, rowIndex) => {
                                        return (
                                            <tr key={rowIndex} style={{ cursor: "pointer" }}>
                                                {columns.map((column, colIndex) => {
                                                    return (
                                                        <td
                                                            key={colIndex}
                                                            className="p-2 text-sm text-nowrap"
                                                            onClick={() => rowClick && rowClick(row)}
                                                            style={{ textAlign: column.align || "left" }}
                                                        >
                                                            {children({ row: row, column: column })}
                                                        </td>
                                                    );
                                                })}
                                            </tr>
                                        );
                                    })}
                                    {currentItems.length === 0 && !isLoader &&
                                        <tr>
                                            <td colSpan={columns.length}>
                                                <div className="d-flex align-items-center justify-content-center flex-column" style={{ height: '200px' }}>
                                                    <img src="/assets/images/No-data.jpg" alt="no data found" style={{ width: 200 }} />
                                                    <h1 className="text-base text-center">No {tableNm} found</h1>
                                                </div>
                                            </td>
                                        </tr>
                                    }
                                </tbody>
                            </Table>
                        </div>
                        {pagination &&
                            <Pagination
                                itemsPerPage={itemsPerPage}
                                setCurrentPage={setCurrentPage}
                                currentPage={currentPage}
                                setItemsPerPage={setItemsPerPage}
                                totalPages={totalPages}
                            />
                        }
                    </div>
                </div>
            </>
        </div >
    );
};